import config from "../../../settings/config";

export async function fetchDeviceService(token, substring, page, size) {
    let newSub = "";
    if (substring != null) {
        newSub = "search=" + substring;
    }
    try {
        const response = await fetch(`${config.app.host}/api/v1/admin/?${newSub}&page=${page}&size=${size}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorMessage = `Ошибка ${response.status}: ${await response.text()}`;
            console.error(errorMessage);
            return null;
        }

        return await response.json();

    } catch (err) {
        console.error("Ошибка при запросе устройств:", err);
        return null;
    } finally {

    }
}

export async function deleteDevice(sn, token) {
    console.log(`SN=${sn} TEST`);
    try {
        const response = await fetch(`${config.app.host}/api/v1/admin/deleteDevice?deviceSn=${sn}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorMessage = `Ошибка ${response.status}: ${await response.text()}`;
            console.error(errorMessage);
            return null;
        }

        return await response.json();

    } catch (err) {
        console.error("Ошибка при отправке команды:", err);
        return null;
    } finally {

    }
}


